
import {gql, MutationHookOptions, useMutation} from '@apollo/client';
import {NamedQueries} from 'constants/queries';

const setPrivacy = gql`
mutation ($doNotSellOrShare: Boolean!, $source: PrivacySource) {
    user {
        privacy(doNotSellOrShare: $doNotSellOrShare, source: $source)
    }
}`;

// The GraphQL enum also has ADMIN, which the site never sends
export type PrivacySource = 'WEB' | 'GPC';

interface Vars {
	doNotSellOrShare: boolean;
	source: PrivacySource;
}

export interface Result {
	user: {
		privacy: boolean;
	}
}

export const useSetPrivacy = (options?: MutationHookOptions<Result, Vars>) => {
	return useMutation<Result, Vars>(
		setPrivacy, {
			refetchQueries: [
				NamedQueries.GET_AUTH,
			],
			...options,
		},
	);
};
